import React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from './shared';

// Todo lo que se configura una vez y después se toca poco, junto en un lugar, para que el menú quede con lo del día a
// día. Cada ítem abre la misma pantalla de siempre (la vista correspondiente).

export const CONFIG_GROUPS: { title: string; items: { label: string; path: string; hint: string }[] }[] = [
  {
    title: 'Producción',
    items: [
      { label: 'Máquinas y matrices', path: '/factory/production/maquinas', hint: 'Inyectoras, matrices, bocas, ciclo y piezas por hora' },
      { label: 'Productos que se lotean', path: '/factory/product-lots/config', hint: 'Peso del lote, peso por pieza, unidades por bolsa y qué lleva cada terminado' },
      { label: 'Armadoras', path: '/factory/outwork/armadoras', hint: 'Quiénes arman a domicilio' },
      { label: 'Precio por bolsa de armado', path: '/factory/outwork/precios', hint: 'Cuánto se paga por bolsa armada' },
    ],
  },
  {
    title: 'Materia prima',
    items: [
      { label: 'Recetas de mezcla y orígenes', path: '/factory/materials/recetas', hint: 'Qué lleva cada mezcla y si la MP es virgen o recuperada' },
      { label: 'Qué MP usa cada producto', path: '/factory/stock/mp-por-producto', hint: 'Kg por unidad: para cuántas alcanza la MP' },
    ],
  },
  {
    title: 'Depósito y mantenimiento',
    items: [
      { label: 'Ubicaciones del depósito', path: '/factory/storage/ubicaciones', hint: 'Racks y estantes (A1, A2…)' },
      { label: 'Tareas de mantenimiento', path: '/factory/maintenance/tareas', hint: 'Preventivos por días, horas o ciclos' },
    ],
  },
  {
    title: 'Ventas',
    items: [
      { label: 'Plantas y expresos de clientes', path: '/factory/customer-orders/plantas', hint: 'Adónde se entrega a cada gasera y con qué transporte' },
    ],
  },
  {
    title: 'Cuenta',
    items: [
      { label: 'Usuarios', path: '/users', hint: 'Quién entra al sistema y con qué permisos' },
      { label: 'Datos de la empresa', path: '/settings', hint: 'Nombre, logo y preferencias' },
    ],
  },
];

export const CONFIG_PATHS = CONFIG_GROUPS.flatMap(g => g.items.map(i => i.path));

const FactoryConfigPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box>
      <PageHeader title="Configuración" description="Lo que se carga una vez: equipos, productos, ubicaciones, tareas y usuarios." />
      <Box sx={{ display: 'grid', gap: 3, gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' } }}>
        {CONFIG_GROUPS.map(g => (
          <Box key={g.title}>
            <Typography sx={{ fontSize: 12.5, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: 'text.secondary', mb: 1 }}>{g.title}</Typography>
            <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', bgcolor: 'background.paper' }}>
              {g.items.map((i, k) => (
                <ButtonBase
                  key={i.path}
                  onClick={() => navigate(i.path)}
                  sx={{
                    display: 'flex', width: '100%', justifyContent: 'flex-start', textAlign: 'left', gap: 2, px: 2, py: 1.5,
                    borderTop: k ? '1px solid' : 'none', borderColor: 'divider', '&:hover': { bgcolor: 'action.hover' },
                  }}
                >
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ fontWeight: 600, fontSize: 15 }}>{i.label}</Typography>
                    <Typography variant="body2" color="text.secondary">{i.hint}</Typography>
                  </Box>
                  <ChevronRight sx={{ color: 'text.disabled' }} />
                </ButtonBase>
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default FactoryConfigPage;
